<template>
  <section>
    <div class="form-tip">
      <p>1、本表作为进度款审核意见单，附有工程量支付清单;</p>
      <p>2、本表位进度款审批流程表， 进度款支付金额需与本表一致。</p>
    </div>
    <div class="tip" style="margin: 0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目需求单位">
          <el-input size="small" :disabled="true" v-model="object.deptName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同编号">
          <el-input size="small" :disabled="true" v-model="object.htbh"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目/合同名称">
          <el-input size="small" v-model="object.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="送审时间">
          <el-date-picker v-model="form.sstime" size="small" value-format="yyyy-MM-dd" type="date"
            placeholder="选择申请印章的时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item class="underline-label" label="已线下通过该审批">
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p class="tip" v-if="form.underLine == '1'" style="padding: 0 10px; border: 1px #d93c37 solid">
        *已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。
      </p>
    </el-form-item>

    <div class="tip" style="margin: 20px 0 0 20px">* 进度款详情</div>
    <div class="clear">
      <div class="approval-form-table">
        <table>
          <tr>
            <td width="50">序号</td>
            <td width="190">项目名称</td>
            <td>合同价(元)</td>
            <td>上期累计支付(元)</td>
            <td>本期支付(元)</td>
            <td>本期累计支付(元)</td>
          </tr>
          <tr v-for="(data, i) in tableData">
            <td>{{ data.xh }}</td>
            <td>
              {{ data.title
              }}<span v-if="
                  data.type == 'blj' ||
                  data.type == 'yk' ||
                  data.type == 'htnkk' ||
                  data.type == 'bgkk'
                ">
                <el-input type="number" size="small" style="width: 70px; margin: 0 5px" v-model="data.num5"
                  @keyup.native="autoCalcTableData()"></el-input>%
              </span>
            </td>
            <td>
              <el-input :disabled="data.disable" @keyup.native="autoCalcTableData()" type="number" size="small"
                v-model="data.num1"></el-input>
            </td>
            <td>
              <el-input :disabled="data.disable" @keyup.native="autoCalcTableData()" type="number" size="small"
                v-model="data.num2"></el-input>
            </td>
            <td>
              <el-input :disabled="data.disable" @keyup.native="autoCalcTableData()" type="number" size="small"
                v-model="data.num3"></el-input>
            </td>
            <td>
              <el-input :disabled="data.disable" @keyup.native="autoCalcTableData()" type="number" size="small"
                v-model="data.num4"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: ["project", "contract", "formByFather", "userData"],
    data() {
      return {
        form: {},
        tableData: [],
        oldTableData: [],
        object: "",
      };
    },
    mounted() {
      console.log(this.project);

      this.form = this.formByFather;
      this.getTableData();

      // 获取历史数据（上一轮已经审批通过的审核单）
      this.getOldTableData();

      this.object = this.project ? this.project : this.contract;
    },
    methods: {
      // 获取上一轮已经审批通过的审核单
      getOldTableData() {
        console.log(this.project);
        console.log(this.contract);

        let _contractId = this.project ?
          this.project.contractId :
          this.contract.id;
        if (this.project.projectIds) {
          _contractId = this.project.id;
          console.log(_contractId);
        }
        if (!_contractId) {
          this.$alert(
            "该工程尚未建立合同，请建立合同后再进行款项支付审核",
            "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.go(-1);
              },
            }
          );
          return;
        }

        // 在查看详情的时候，不去调用上期的历史数据
        this.$nextTick(() => {
          this.setTableData();
        });
        // ajax.get("/gc/project/money/approval/last/" + _contractId, "", (res) => {
        //   if (res && res.vo) {
        //     this.oldTableData = res.vo
        //     this.setOldItemData()
        //   } else {
        //     this.setTableData()
        //   }
        // })
      },
      // 设置历史累计支付金额
      setOldItemData() {
        // for (let key in this.oldTableData) {
        //   if (key != 'id' && key != 'sstime') {
        //     let _old_item = this.oldTableData[key].split(",")
        //     let _item = this.form[key].split(",")
        //     _item[0] = _old_item[0]
        //     _item[1] = _old_item[3]
        //     this.form[key] = _item.join(",")
        //   }
        // }
        // this.setTableData()
      },
      getFromDataByTableData() {
        for (var i = 0; i < this.tableData.length; i++) {
          let _data = this.tableData[i];

          if (!_data.num1) {
            _data.num1 = 0
          }
          if (!_data.num2) {
            _data.num2 = 0
          }
          if (!_data.num3) {
            _data.num3 = 0
          }
          if (!_data.num4) {
            _data.num4 = 0
          }
          if (!_data.num5) {
            _data.num5 = 0
          }

          let _data_string =
            _data.num1 + "," + _data.num2 + "," + _data.num3 + "," + _data.num4;
          switch (i) {
            case 0:
              this.form.jbzf = _data_string;
              break;
            case 1:
              this.form.azf = _data_string;
              break;
            case 2:
              this.form.bxfxm = _data_string;
              break;
            case 3:
              this.form.zlj = _data_string;
              break;
            case 4:
              this.form.gcbg = _data_string;
              break;
            case 5:
              this.form.jgtz = _data_string;
              break;
            case 6:
              this.form.gcyfk = _data_string;
              break;
            case 7:
              this.form.xj = _data_string;
              break;
            case 8:
              this.form.kkxm = _data_string;
              break;
            case 9:
              this.form.hkgcyfk = _data_string;
              break;
            case 10:
              this.form.blj = _data_string + "," + _data.num5;
              break;
            case 11:
              this.form.htnkk = _data_string + "," + _data.num5;
              break;
            case 12:
              this.form.bgkk = _data_string + "," + _data.num5;
              break;
            case 13:
              this.form.sjzf = _data_string;
              break;
          }
        }
      },
      getTableData() {
        this.tableData = [{
            xh: 1,
            title: "基本支付",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            disable: true,
          },
          {
            xh: "",
            title: "1、安装费",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: "",
            title: "2、不下浮项目",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: "",
            title: "3、暂列金",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: 2,
            title: "工程变更",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: 3,
            title: "价格调整",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: 4,
            title: "工程预付款",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: 5,
            title: "小计",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            disable: true,
          },
          {
            xh: 6,
            title: "扣款项目",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            disable: true,
          },
          {
            xh: "",
            title: "4、回扣工程预付款",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
          },
          {
            xh: "",
            title: "5、保留金",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            num5: 5,
            type: "blj",
            disable: true,
          },
          {
            xh: "",
            title: "6、合同内扣款",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            num5: 1,
            type: "htnkk",
            disable: true,
          },
          {
            xh: "",
            title: "7、变更扣款",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            num5: 2,
            type: "bgkk",
            disable: true,
          },
          {
            xh: 7,
            title: "实际支付",
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            disable: true,
          },
        ];
      },
      setItemData(item, obj) {
        if (!obj) {
          return;
        }
        let objs = obj.split(",");
        item.num1 = objs[0] / 1;
        item.num2 = objs[1] / 1;
        item.num3 = objs[2] / 1;
        item.num4 = objs[3] / 1;
        if (
          item.type == "blj" ||
          item.type == "yk" ||
          item.type == "htnkk" ||
          item.type == "bgkk"
        ) {
          item.num5 = objs[4] / 1;
        }
      },
      setTableData() {
        for (var i = 0; i < this.tableData.length; i++) {
          let item = this.tableData[i];
          switch (i) {
            case 0:
              this.setItemData(item, this.form.jbzf);
              break;
            case 1:
              this.setItemData(item, this.form.azf);
              break;
            case 2:
              this.setItemData(item, this.form.bxfxm);
              break;
            case 3:
              this.setItemData(item, this.form.zlj);
              break;
            case 4:
              this.setItemData(item, this.form.gcbg);
              break;
            case 5:
              this.setItemData(item, this.form.jgtz);
              break;
            case 6:
              this.setItemData(item, this.form.gcyfk);
              break;
            case 7:
              this.setItemData(item, this.form.xj);
              break;
            case 8:
              this.setItemData(item, this.form.kkxm);
              break;
            case 9:
              this.setItemData(item, this.form.hkgcyfk);
              break;
            case 10:
              this.setItemData(item, this.form.blj);
              break;
            case 11:
              this.setItemData(item, this.form.htnkk);
              break;
            case 12:
              this.setItemData(item, this.form.bgkk);
              break;
            case 13:
              this.setItemData(item, this.form.sjzf);
              break;
          }

          this.$set(this.tableData, i, item);
        }
        console.log(this.tableData);
      },
      getFromData() {
        this.getFromDataByTableData();
        return this.form;
      },
      calcTableData(f, s, type, calcAll) {
        // type: 0: 加法   1：乘法
        let _num1 = 0,
          _num2 = 0,
          _num3 = 0,
          _num4 = 0;

        switch (type) {
          case 0:
            // 项目加法
            for (let i = 0; i < s.length; i++) {
              if (calcAll) {
                _num1 += s[i]["num1"] / 1;
                _num2 += s[i]["num2"] / 1;
              }
              _num3 += s[i]["num3"] / 1;
              _num4 += s[i]["num4"] / 1;
            }
            break;
          case 1:
            // 系数乘法
            if (calcAll) {
              _num1 = Math.round(((s["num1"] / 1) * (f["num5"] / 1)) / 100);
              _num2 = Math.round(((s["num2"] / 1) * (f["num5"] / 1)) / 100);
            }
            _num3 = Math.round(((s["num3"] / 1) * (f["num5"] / 1)) / 100);
            _num4 = Math.round(((s["num4"] / 1) * (f["num5"] / 1)) / 100);
            break;
          case 2:
            // 项目减法
            if (calcAll) {
              _num1 = s[0]["num1"] / 1 - s[1]["num1"] / 1;
              _num2 = s[0]["num2"] / 1 - s[1]["num2"] / 1;
            }
            _num3 = s[0]["num3"] / 1 - s[1]["num3"] / 1;
            _num4 = s[0]["num4"] / 1 - s[1]["num4"] / 1;
            break;
        }

        if (calcAll) {
          f["num1"] = _num1;
          f["num2"] = _num2;
        }
        f["num3"] = _num3;
        f["num4"] = _num4;
      },
      autoCalcTableData() {
        // 本期累计支付
        for (let i = 0; i < this.tableData.length; i++) {
          let _item = this.tableData[i];
          _item["num4"] = _item["num2"] / 1 + _item["num3"] / 1;
        }

        // 基本支付
        this.calcTableData(
          this.tableData[0],
          [this.tableData[1], this.tableData[2], this.tableData[3]],
          0,
          true
        );
        // 小计
        this.calcTableData(
          this.tableData[7],
          [
            this.tableData[0],
            this.tableData[4],
            this.tableData[5],
            this.tableData[6],
          ],
          0
        );
        // 保留金
        this.calcTableData(this.tableData[10], this.tableData[7], 1);

        // 6、合同内扣款
        this.calcTableData(this.tableData[11], this.tableData[0], 1);
        // 7、变更扣款
        this.calcTableData(this.tableData[12], this.tableData[4], 1);
        // 扣款项目
        this.calcTableData(
          this.tableData[8],
          [
            this.tableData[9],
            this.tableData[10],
            this.tableData[11],
            this.tableData[12],
          ],
          0
        );
        // 实际支付
        this.calcTableData(
          this.tableData[13],
          [this.tableData[7], this.tableData[8]],
          2
        );
      },
    },
    watch: {
      formByFather: {
        handler: (val, oldVal) => {
          this.form = this.formByFather;
        },
        deep: true,
      },
      form() {
        this.getTableData();
      },
    },
  };

</script>



// WEBPACK FOOTER //
// src/page/form/createMoneyApprovalInfo.vue